export default "__VITE_ASSET__DMsAwejV__"